import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

export const modalLgOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'lg'
};
export const modalXlOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'xl',
};
export const modalXlFilterOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    // centered: true,
    size: 'xl'
};
export const modalMdOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'md'
};

export const modalSmOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
};

export const modalFullScreenXLOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    fullscreen: true
};

export const modalDesingMasterOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'xl',
    windowClass: 'modal-stack'
};

